<div class="container">
  <div class="row">
    <div class="col-md-8 col-lg-6 mx-auto">
      <div class="alternative-receive-code">
        <div class="header-message">
          If you have trouble receiving the passcode, you can use these alternative methods</div>
        <div class="form-wrapper">
          <div class="form-group">
            <button class="btn btn-block btn-greengo" type="button" (click)="onClick()" npFocusOutClicked>Send SMS text message to my registered landline</button>
          </div>
          <div class="form-group">
            <button class="btn btn-block btn-greengo" type="button" (click)="onClick()" npFocusOutClicked>Email support or call us on +44(0)20 1234 5678</button>
          </div>
          <div class="return-login">
            <a routerLink="/auth/login" class="link return-login-link">Return to log in</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>